export default {
  payloadTypeId: {
    label: '设备类型',
    type: 'select',
    relation: 'counterTypeId',
    width: 200,
    minLength: 300,
    form: {
      type: 'select',
      size: 10,
      disabled: true,
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    }
  },
  code: {
    label: '设备编号',
    width: 150,
    form: {
      type: 'input',
      size: 12,
      disabled: true,
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    }
  },
  collectorId: {
    label: '所属采集器',
    width: 120,
    type: 'select',
    relation: 'collectorsAll',
    form: {
      type: 'select',
      disabled: true,
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    }
  },
  collectorCode: {
    label: '采集器编号',
    width: 150,
    form: {
      type: 'input',
      disabled: true,
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    }
  },
  repeaterType: {
    label: '所属中继器类型',
    width: 100,
    relation: 'repeaterTypeId',
    form: {
      type: 'select',
      size: 10,
      disabled: true,
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    }
  },
  repeaterCode: {
    label: '中继器编号',
    width: 100,
    form: {
      type: 'input',
      size: 10,
      disabled: true,
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/NB/unEditColumns.js